import routerName from './router-name';
import sidebarMenu from './sidebar-menu';
const id = {
    routerName,
    sidebarMenu
};
export default id;
